import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "캐싱",
  "description": "Turborepo의 캐싱에 대해 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo는 캐싱을 사용하여 빌드 속도를 높이고, 동일한 작업을 두 번 수행하지 않도록 보장합니다. 작업이 캐시 가능한 경우, Turborepo는 작업이 처음 실행되었을 때의 지문을 사용하여 캐시에서 작업 결과를 복원합니다."
  }, {
    "heading": "",
    "content": "Turborepo의 캐싱은 로컬에서 작업할 때 상당한 시간을 절약해주며, Remote Caching을 활성화하면 전체 팀과 CI에서 캐시를 공유하여 훨씬 더 강력해집니다."
  }, {
    "heading": "",
    "content": "이 페이지에서는 다음을 배웁니다:"
  }, {
    "heading": "",
    "content": "첫 번째 Turborepo 캐시 히트를 달성하는 방법"
  }, {
    "heading": "",
    "content": "Remote Caching을 활성화하는 방법"
  }, {
    "heading": "",
    "content": "Turborepo가 해시의 입력 및 출력으로 사용하는 것"
  }, {
    "heading": "",
    "content": "캐싱 문제를 해결하는 방법"
  }, {
    "heading": "",
    "content": "Turborepo는 작업이 결정적이라고 가정합니다. 작업이 Turborepo가 인식하는\n입력 세트가 주어졌을 때 다른 출력을 생성할 수 있다면, 캐싱이 예상대로 작동하지\n않을 수 있습니다."
  }, {
    "heading": "첫-번째-turborepo-캐시-히트",
    "content": "세 단계로 Turborepo의 캐싱 동작을 시도해볼 수 있습니다:"
  }, {
    "heading": "새-turborepo-프로젝트-생성",
    "content": "npx create-turbo@latest를 사용하고 프롬프트를 따라 새 Turborepo를 생성합니다."
  }, {
    "heading": "첫-번째-빌드-실행",
    "content": "turbo를 전역으로 설치한 경우 저장소에서 turbo build를 실행합니다."
  }, {
    "heading": "첫-번째-빌드-실행",
    "content": "또는 패키지 관리자를 사용하여 package.json의 build 스크립트를 실행할 수 있습니다."
  }, {
    "heading": "첫-번째-빌드-실행",
    "content": "이 결과로 캐시 미스가 발생합니다. 이 저장소에서 이 입력 세트로 turbo를 실행한 적이 없기 때문입니다. 입력은 로컬 파일 시스템 캐시 또는 Remote Cache에서 확인할 해시로 변환됩니다."
  }, {
    "heading": "캐시-히트",
    "content": "turbo build를 다시 실행합니다. 다음과 같은 메시지가 표시됩니다:"
  }, {
    "heading": "캐시-히트",
    "content": "입력의 지문이 이미 캐시에 있기 때문에 애플리케이션을 다시 빌드할 이유가 없습니다. 이전 빌드의 결과를 캐시에서 복원하여 리소스와 시간을 절약할 수 있습니다."
  }, {
    "heading": "remote-caching",
    "content": "Turborepo는 작업 결과를 머신의 .turbo/cache 디렉토리에 저장합니다. 그러나 이 캐시를 팀원 및 CI와 공유하여 전체 조직의 속도를 더욱 높일 수 있습니다."
  }, {
    "heading": "remote-caching",
    "content": "Remote Caching과 그 이점에 대해 자세히 알아보려면 Remote Caching 페이지를 방문하세요."
  }, {
    "heading": "remote-cache-활성화",
    "content": "먼저 Remote Cache 제공자로 인증합니다:"
  }, {
    "heading": "remote-cache-활성화",
    "content": "그런 다음 머신의 저장소를 Remote Cache에 연결합니다:"
  }, {
    "heading": "remote-cache-활성화",
    "content": "이제 작업을 실행하면 Turborepo가 자동으로 작업의 출력을 Remote Cache로 전송합니다. Remote Cache에 인증된 다른 머신에서 동일한 작업을 실행하면 처음 작업을 실행할 때 캐시를 히트합니다."
  }, {
    "heading": "remote-cache-활성화",
    "content": "CI 머신을 Remote Cache에 연결하는 방법에 대한 정보는 CI 구성 가이드를 방문하세요."
  }, {
    "heading": "remote-cache-활성화",
    "content": "기본적으로 Turborepo는 제로 구성으로 Vercel Remote\nCache를 사용합니다. 다른\nRemote Cache를 사용하려면 Remote Caching API\n문서를 방문하세요."
  }, {
    "heading": "무엇이-캐시되나요",
    "content": "Turborepo는 두 가지 유형의 출력을 캐시합니다: 작업 출력과 로그입니다."
  }, {
    "heading": "작업-출력",
    "content": "Turborepo는 turbo.json의 outputs 키에 정의된 작업의 파일 출력을 캐시합니다. 캐시 히트가 발생하면 Turborepo는 캐시에서 파일을 복원합니다."
  }, {
    "heading": "작업-출력",
    "content": "outputs 키는 선택 사항입니다. 이 경우 Turborepo가 어떻게 동작하는지는 API 참조를 참조하세요."
  }, {
    "heading": "작업-출력",
    "content": "작업에 대한 파일 출력을 선언하지 않으면 Turborepo는 해당 출력을 캐시하지 않습니다. 일부 작업(예: linter)에는 괜찮을 수 있지만, 많은 작업은 캐시하고 싶은 파일을 생성합니다."
  }, {
    "heading": "작업-출력",
    "content": "캐시를 히트할 때 파일을 사용할 수 없다는 오류가 발생하는 경우 작업에 대한 출력을 정의했는지 확인하세요."
  }, {
    "heading": "로그",
    "content": "Turborepo는 항상 작업의 터미널 출력을 캡처하여 작업이 처음 실행되었을 때의 로그를 터미널에 복원합니다."
  }, {
    "heading": "로그",
    "content": "재생된 로그의 세부 수준은 --output-logs 플래그 또는 outputLogs 구성 옵션을 사용하여 구성할 수 있습니다."
  }, {
    "heading": "작업-입력",
    "content": "입력은 Turborepo에 의해 해시되어 작업 실행에 대한 \"지문\"을 생성합니다. \"지문\"이 일치하면 작업 실행이 캐시를 히트합니다."
  }, {
    "heading": "작업-입력",
    "content": "내부적으로 Turborepo는 전역 해시와 작업 해시의 두 가지 해시를 생성합니다. 해시 중 하나라도 변경되면 작업이 캐시를 미스합니다."
  }, {
    "heading": "전역-해시-입력",
    "content": "입력"
  }, {
    "heading": "전역-해시-입력",
    "content": "예시"
  }, {
    "heading": "전역-해시-입력",
    "content": "루트 turbo.json 및 패키지 turbo.json의 해결된 작업 정의"
  }, {
    "heading": "전역-해시-입력",
    "content": "루트 turbo.json 또는 패키지 구성에서 outputs 변경"
  }, {
    "heading": "전역-해시-입력",
    "content": "Workspace 루트에 영향을 미치는 Lockfile 변경"
  }, {
    "heading": "전역-해시-입력",
    "content": "루트 package.json의 종속성 업데이트는 모든 작업이 캐시를 미스하게 함"
  }, {
    "heading": "전역-해시-입력",
    "content": "globalDependencies 파일 내용"
  }, {
    "heading": "전역-해시-입력",
    "content": "globalDependencies에 나열된 ./.env 변경은 모든 작업이 캐시를 미스하게 함"
  }, {
    "heading": "전역-해시-입력",
    "content": "globalEnv에 나열된 변수의 값"
  }, {
    "heading": "전역-해시-입력",
    "content": "globalEnv에 나열된 GITHUB_TOKEN 값 변경"
  }, {
    "heading": "전역-해시-입력",
    "content": "작업 런타임에 영향을 미치는 플래그 값"
  }, {
    "heading": "전역-해시-입력",
    "content": "--cache-dir, --framework-inference 또는 --env-mode와 같은 동작 변경 플래그 사용"
  }, {
    "heading": "전역-해시-입력",
    "content": "임의 패스스루 인수"
  }, {
    "heading": "전역-해시-입력",
    "content": "turbo build -- --arg=value는 turbo build 또는 turbo build -- --arg=diff와 비교하여 캐시를 미스함"
  }, {
    "heading": "패키지-해시-입력",
    "content": "입력"
  }, {
    "heading": "패키지-해시-입력",
    "content": "예시"
  }, {
    "heading": "패키지-해시-입력",
    "content": "패키지 구성 변경"
  }, {
    "heading": "패키지-해시-입력",
    "content": "패키지의 turbo.json 변경"
  }, {
    "heading": "패키지-해시-입력",
    "content": "패키지에 영향을 미치는 Lockfile 변경"
  }, {
    "heading": "패키지-해시-입력",
    "content": "패키지의 package.json에서 종속성 업데이트"
  }, {
    "heading": "패키지-해시-입력",
    "content": "패키지의 package.json 변경"
  }, {
    "heading": "패키지-해시-입력",
    "content": "패키지의 package.json에서 name 필드 업데이트"
  }, {
    "heading": "패키지-해시-입력",
    "content": "소스 제어의 파일 변경"
  }, {
    "heading": "패키지-해시-입력",
    "content": "src/index.ts에 새 코드 작성"
  }, {
    "heading": "dry-run-사용",
    "content": "Turborepo에는 실제로 실행하지 않고 작업을 실행하면 어떤 일이 발생하는지 확인할 수 있는 --dry 플래그가 있습니다. 이는 어떤 작업을 실행하고 있는지 확실하지 않을 때 캐싱 문제를 디버깅하는 데 유용할 수 있습니다."
  }, {
    "heading": "dry-run-사용",
    "content": "자세한 내용은 --dry API 참조를 방문하세요."
  }, {
    "heading": "run-summary-사용",
    "content": "Turborepo에는 작업의 모든 입력, 출력 등에 대한 개요를 얻는 데 사용할 수 있는 --summarize 플래그가 있습니다. 두 요약을 비교하면 두 작업의 해시가 다른 이유를 알 수 있습니다. 이는 다음과 같은 경우에 유용할 수 있습니다:"
  }, {
    "heading": "run-summary-사용",
    "content": "입력 디버깅: Turborepo의 작업에는 많은 입력이 있습니다. 작업이 캐시를 히트할 것으로 예상했는데 미스하는 경우 Run Summary를 사용하여 예상하지 못한 입력이 다른지 확인할 수 있습니다."
  }, {
    "heading": "run-summary-사용",
    "content": "출력 디버깅: 캐시 히트가 예상한 파일을 복원하지 않는 경우 Run Summary는 캐시에서 복원되는 출력을 이해하는 데 도움이 될 수 있습니다."
  }, {
    "heading": "run-summary-사용",
    "content": "Turborepo 네이티브 Run Summary UI 뷰어는 없지만, Run Summary를 웹 뷰로 보고\n싶다면 커뮤니티에서 만든\nhttps://turbo.nullvoxpopuli.com을 사용하는\n것을 권장합니다."
  }, {
    "heading": "캐싱-끄기",
    "content": "때때로 작업의 출력을 캐시에 쓰지 않을 수 있습니다. 이는 \"cache\": false를 사용하여 작업에 대해 영구적으로 설정하거나 the --cache <options> 플래그를 사용하여 전체 실행에 대해 설정할 수 있습니다."
  }, {
    "heading": "캐시-덮어쓰기",
    "content": "캐시된 작업을 강제로 다시 실행하려면 --force 플래그를 사용합니다. 이는 캐시 읽기를 비활성화하며 쓰기는 비활성화하지 않습니다."
  }, {
    "heading": "작업-캐싱이-작업-실행보다-느림",
    "content": "캐싱이 캐싱하지 않는 것보다 느린 시나리오를 만드는 것이 가능합니다. 이러한 경우는 드물지만 몇 가지 예는 다음과 같습니다:"
  }, {
    "heading": "작업-캐싱이-작업-실행보다-느림",
    "content": "매우 빠르게 실행되는 작업: 작업이 Remote Cache로의 네트워크 왕복보다 빠르게 실행되는 경우 작업을 캐시하지 않는 것을 고려해야 합니다."
  }, {
    "heading": "작업-캐싱이-작업-실행보다-느림",
    "content": "출력 자산이 엄청나게 큰 작업: 업로드 또는 다운로드하는 데 걸리는 시간이 재생성하는 데 걸리는 시간을 초과하는 것처럼 완전한 Docker 컨테이너와 같이 너무 큰 아티팩트를 만드는 것이 가능합니다. 이러한 경우 작업을 캐시하지 않는 것을 고려해야 합니다."
  }, {
    "heading": "작업-캐싱이-작업-실행보다-느림",
    "content": "자체 캐싱이 있는 스크립트: 일부 작업에는 자체 내부 캐싱 동작이 있습니다. 이러한 경우 Turborepo의 캐시와 애플리케이션 캐시가 함께 작동하도록 구성이 빠르게 복잡해질 수 있습니다."
  }, {
    "heading": "작업-캐싱이-작업-실행보다-느림",
    "content": "이러한 상황은 드물지만 특정 위치에서 캐싱을 비활성화하는 것이 성능 이점을 제공하는지 확인하기 위해 프로젝트의 동작을 테스트해야 합니다."
  }, {
    "heading": "다음-단계",
    "content": "이제 Turborepo의 캐싱이 저장소를 어떻게 더 빠르게 만드는지 보았으므로 Turborepo에서 애플리케이션과 라이브러리를 개발하는 방법을 살펴보겠습니다."
  }],
  "headings": [{
    "id": "첫-번째-turborepo-캐시-히트",
    "content": "첫 번째 Turborepo 캐시 히트"
  }, {
    "id": "새-turborepo-프로젝트-생성",
    "content": "새 Turborepo 프로젝트 생성"
  }, {
    "id": "첫-번째-빌드-실행",
    "content": "첫 번째 빌드 실행"
  }, {
    "id": "캐시-히트",
    "content": "캐시 히트"
  }, {
    "id": "remote-caching",
    "content": "Remote Caching"
  }, {
    "id": "remote-cache-활성화",
    "content": "Remote Cache 활성화"
  }, {
    "id": "무엇이-캐시되나요",
    "content": "무엇이 캐시되나요?"
  }, {
    "id": "작업-출력",
    "content": "작업 출력"
  }, {
    "id": "로그",
    "content": "로그"
  }, {
    "id": "작업-입력",
    "content": "작업 입력"
  }, {
    "id": "전역-해시-입력",
    "content": "전역 해시 입력"
  }, {
    "id": "패키지-해시-입력",
    "content": "패키지 해시 입력"
  }, {
    "id": "문제-해결",
    "content": "문제 해결"
  }, {
    "id": "dry-run-사용",
    "content": "Dry run 사용"
  }, {
    "id": "run-summary-사용",
    "content": "Run Summary 사용"
  }, {
    "id": "캐싱-끄기",
    "content": "캐싱 끄기"
  }, {
    "id": "캐시-덮어쓰기",
    "content": "캐시 덮어쓰기"
  }, {
    "id": "작업-캐싱이-작업-실행보다-느림",
    "content": "작업 캐싱이 작업 실행보다 느림"
  }, {
    "id": "다음-단계",
    "content": "다음 단계"
  }]
};
import __img0 from "./../../../public/images/docs/why-turborepo-solution.png";
import __img1 from "./../../../public/images/docs/full-turbo.png";
import {Step, Steps} from '#components/steps';
import {PackageManagerTabs, Tab} from '#components/tabs';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#첫-번째-turborepo-캐시-히트",
  title: _jsx(_Fragment, {
    children: "첫 번째 Turborepo 캐시 히트"
  })
}, {
  depth: 3,
  url: "#새-turborepo-프로젝트-생성",
  title: _jsx(_Fragment, {
    children: "새 Turborepo 프로젝트 생성"
  })
}, {
  depth: 3,
  url: "#첫-번째-빌드-실행",
  title: _jsx(_Fragment, {
    children: "첫 번째 빌드 실행"
  })
}, {
  depth: 3,
  url: "#캐시-히트",
  title: _jsx(_Fragment, {
    children: "캐시 히트"
  })
}, {
  depth: 2,
  url: "#remote-caching",
  title: _jsx(_Fragment, {
    children: "Remote Caching"
  })
}, {
  depth: 3,
  url: "#remote-cache-활성화",
  title: _jsx(_Fragment, {
    children: "Remote Cache 활성화"
  })
}, {
  depth: 2,
  url: "#무엇이-캐시되나요",
  title: _jsx(_Fragment, {
    children: "무엇이 캐시되나요?"
  })
}, {
  depth: 3,
  url: "#작업-출력",
  title: _jsx(_Fragment, {
    children: "작업 출력"
  })
}, {
  depth: 3,
  url: "#로그",
  title: _jsx(_Fragment, {
    children: "로그"
  })
}, {
  depth: 2,
  url: "#작업-입력",
  title: _jsx(_Fragment, {
    children: "작업 입력"
  })
}, {
  depth: 3,
  url: "#전역-해시-입력",
  title: _jsx(_Fragment, {
    children: "전역 해시 입력"
  })
}, {
  depth: 3,
  url: "#패키지-해시-입력",
  title: _jsx(_Fragment, {
    children: "패키지 해시 입력"
  })
}, {
  depth: 2,
  url: "#문제-해결",
  title: _jsx(_Fragment, {
    children: "문제 해결"
  })
}, {
  depth: 3,
  url: "#dry-run-사용",
  title: _jsx(_Fragment, {
    children: "Dry run 사용"
  })
}, {
  depth: 3,
  url: "#run-summary-사용",
  title: _jsx(_Fragment, {
    children: "Run Summary 사용"
  })
}, {
  depth: 3,
  url: "#캐싱-끄기",
  title: _jsx(_Fragment, {
    children: "캐싱 끄기"
  })
}, {
  depth: 3,
  url: "#캐시-덮어쓰기",
  title: _jsx(_Fragment, {
    children: "캐시 덮어쓰기"
  })
}, {
  depth: 3,
  url: "#작업-캐싱이-작업-실행보다-느림",
  title: _jsx(_Fragment, {
    children: "작업 캐싱이 작업 실행보다 느림"
  })
}, {
  depth: 2,
  url: "#다음-단계",
  title: _jsx(_Fragment, {
    children: "다음 단계"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    img: "img",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo는 캐싱을 사용하여 빌드 속도를 높이고, ", _jsx(_components.strong, {
        children: "동일한 작업을 두 번 수행하지 않도록"
      }), " 보장합니다. 작업이 캐시 가능한 경우, Turborepo는 작업이 처음 실행되었을 때의 지문을 사용하여 캐시에서 작업 결과를 복원합니다."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "12 tasks are being ran in 3 packages, resulting in a \">>> FULL TURBO\" cache hit. The total time it takes to restore these tasks from cache is 80 milliseconds.",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo의 캐싱은 로컬에서 작업할 때 상당한 시간을 절약해주며, ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), "을 활성화하면 전체 팀과 CI에서 캐시를 공유하여 훨씬 더 강력해집니다."]
    }), "\n", _jsx(_components.p, {
      children: "이 페이지에서는 다음을 배웁니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#hit-your-first-turborepo-cache",
          children: "첫 번째 Turborepo 캐시 히트를 달성하는 방법"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching",
          children: "Remote Caching을 활성화하는 방법"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/crafting-your-repository/caching#task-inputs",
          children: "Turborepo가 해시의 입력 및 출력으로 사용하는 것"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#troubleshooting",
          children: "캐싱 문제를 해결하는 방법"
        })
      }), "\n"]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: ["Turborepo는 작업이 ", _jsx(_components.strong, {
          children: "결정적"
        }), "이라고 가정합니다. 작업이 Turborepo가 인식하는\n입력 세트가 주어졌을 때 다른 출력을 생성할 수 있다면, 캐싱이 예상대로 작동하지\n않을 수 있습니다."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "첫-번째-turborepo-캐시-히트",
      children: "첫 번째 Turborepo 캐시 히트"
    }), "\n", _jsx(_components.p, {
      children: "세 단계로 Turborepo의 캐싱 동작을 시도해볼 수 있습니다:"
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "새-turborepo-프로젝트-생성",
          children: "새 Turborepo 프로젝트 생성"
        }), _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "npx create-turbo@latest"
          }), "를 사용하고 프롬프트를 따라 새 Turborepo를 생성합니다."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "첫-번째-빌드-실행",
          children: "첫 번째 빌드 실행"
        }), _jsxs(_components.p, {
          children: [_jsxs(_components.a, {
            href: "/docs/getting-started/installation#global-installation",
            children: [_jsx(_components.code, {
              children: "turbo"
            }), "를 전역으로 설치"]
          }), "한 경우 저장소에서 ", _jsx(_components.code, {
            children: "turbo build"
          }), "를 실행합니다."]
        }), _jsxs(_components.p, {
          children: ["또는 패키지 관리자를 사용하여 ", _jsx(_components.code, {
            children: "package.json"
          }), "의 ", _jsx(_components.code, {
            children: "build"
          }), " 스크립트를 실행할 수 있습니다."]
        }), _jsxs(PackageManagerTabs, {
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " run"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " build"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " build"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " run"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " build"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun (Beta)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " run"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " build"
                    })]
                  })
                })
              })
            })
          })]
        }), _jsxs(_components.p, {
          children: ["이 결과로 캐시 미스가 발생합니다. 이 저장소에서 이 ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/caching#task-inputs",
            children: "입력 세트"
          }), "로 ", _jsx(_components.code, {
            children: "turbo"
          }), "를 실행한 적이 없기 때문입니다. 입력은 로컬 파일 시스템 캐시 또는 ", _jsx(_components.a, {
            href: "/docs/core-concepts/remote-caching",
            children: "Remote Cache"
          }), "에서 확인할 해시로 변환됩니다."]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "캐시-히트",
          children: "캐시 히트"
        }), _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo build"
          }), "를 다시 실행합니다. 다음과 같은 메시지가 표시됩니다:"]
        }), _jsx(_components.p, {
          children: _jsx(_components.img, {
            alt: "A terminal window showing two tasks that have been ran through turbo. They successfully complete in 116 milliseconds.",
            placeholder: "blur",
            src: __img1
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "입력의 지문이 이미 캐시에 있기 때문에 애플리케이션을 다시 빌드할 이유가 없습니다. 이전 빌드의 결과를 캐시에서 복원하여 리소스와 시간을 절약할 수 있습니다."
    }), "\n", _jsx(_components.h2, {
      id: "remote-caching",
      children: "Remote Caching"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 작업 결과를 머신의 ", _jsx(_components.code, {
        children: ".turbo/cache"
      }), " 디렉토리에 저장합니다. 그러나 이 캐시를 팀원 및 CI와 공유하여 전체 조직의 속도를 더욱 높일 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["Remote Caching과 그 이점에 대해 자세히 알아보려면 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching 페이지"
      }), "를 방문하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "remote-cache-활성화",
      children: "Remote Cache 활성화"
    }), "\n", _jsx(_components.p, {
      children: "먼저 Remote Cache 제공자로 인증합니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "그런 다음 머신의 저장소를 Remote Cache에 연결합니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " link"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이제 작업을 실행하면 Turborepo가 자동으로 작업의 출력을 Remote Cache로 전송합니다. Remote Cache에 인증된 다른 머신에서 동일한 작업을 실행하면 처음 작업을 실행할 때 캐시를 히트합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["CI 머신을 Remote Cache에 연결하는 방법에 대한 정보는 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/constructing-ci#enabling-remote-caching",
        children: "CI 구성 가이드"
      }), "를 방문하세요."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["기본적으로 Turborepo는 제로 구성으로 ", _jsx(_components.a, {
          href: "https://vercel.com/docs/monorepos/remote-caching",
          children: "Vercel Remote\nCache"
        }), "를 사용합니다. 다른\nRemote Cache를 사용하려면 ", _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching#self-hosting",
          children: "Remote Caching API\n문서"
        }), "를 방문하세요."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "무엇이-캐시되나요",
      children: "무엇이 캐시되나요?"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 두 가지 유형의 출력을 캐시합니다: 작업 출력과 로그입니다."
    }), "\n", _jsx(_components.h3, {
      id: "작업-출력",
      children: "작업 출력"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "의 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: [_jsx(_components.code, {
          children: "outputs"
        }), " 키"]
      }), "에 정의된 작업의 파일 출력을 캐시합니다. 캐시 히트가 발생하면 Turborepo는 캐시에서 파일을 복원합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "outputs"
      }), " 키는 선택 사항입니다. 이 경우 Turborepo가 어떻게 동작하는지는 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: "API 참조"
      }), "를 참조하세요."]
    }), "\n", _jsxs(Callout, {
      type: "warn",
      title: "파일 출력 제공",
      children: [_jsx(_components.p, {
        children: "작업에 대한 파일 출력을 선언하지 않으면 Turborepo는 해당 출력을 캐시하지 않습니다. 일부 작업(예: linter)에는 괜찮을 수 있지만, 많은 작업은 캐시하고 싶은 파일을 생성합니다."
      }), _jsx(_components.p, {
        children: "캐시를 히트할 때 파일을 사용할 수 없다는 오류가 발생하는 경우 작업에 대한 출력을 정의했는지 확인하세요."
      })]
    }), "\n", _jsx(_components.h3, {
      id: "로그",
      children: "로그"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 항상 작업의 터미널 출력을 캡처하여 작업이 처음 실행되었을 때의 로그를 터미널에 복원합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["재생된 로그의 세부 수준은 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--output-logs-option",
        children: [_jsx(_components.code, {
          children: "--output-logs"
        }), " 플래그"]
      }), " 또는 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputlogs",
        children: [_jsx(_components.code, {
          children: "outputLogs"
        }), " 구성 옵션"]
      }), "을 사용하여 구성할 수 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "작업-입력",
      children: "작업 입력"
    }), "\n", _jsx(_components.p, {
      children: "입력은 Turborepo에 의해 해시되어 작업 실행에 대한 \"지문\"을 생성합니다. \"지문\"이 일치하면 작업 실행이 캐시를 히트합니다."
    }), "\n", _jsx(_components.p, {
      children: "내부적으로 Turborepo는 전역 해시와 작업 해시의 두 가지 해시를 생성합니다. 해시 중 하나라도 변경되면 작업이 캐시를 미스합니다."
    }), "\n", _jsx(_components.h3, {
      id: "전역-해시-입력",
      children: "전역 해시 입력"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "입력"
          }), _jsx(_components.th, {
            children: "예시"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: ["루트 ", _jsx(_components.code, {
              children: "turbo.json"
            }), " 및 패키지 ", _jsx(_components.code, {
              children: "turbo.json"
            }), "의", _jsx("br", {}), " 해결된 작업 정의"]
          }), _jsxs(_components.td, {
            children: ["루트 ", _jsx(_components.code, {
              children: "turbo.json"
            }), " 또는 ", _jsx(_components.a, {
              href: "/docs/reference/package-configurations",
              children: "패키지 구성"
            }), "에서 ", _jsx(_components.a, {
              href: "/docs/reference/configuration#outputs",
              children: _jsx(_components.code, {
                children: "outputs"
              })
            }), " 변경"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Workspace 루트에 영향을 미치는 Lockfile 변경"
          }), _jsxs(_components.td, {
            children: ["루트 ", _jsx(_components.code, {
              children: "package.json"
            }), "의 종속성 업데이트는 ", _jsx(_components.strong, {
              children: "모든"
            }), " 작업이 캐시를 미스하게 함"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.a, {
              href: "/docs/reference/configuration#globaldependencies",
              children: _jsx(_components.code, {
                children: "globalDependencies"
              })
            }), " 파일 내용"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "globalDependencies"
            }), "에 나열된 ", _jsx(_components.code, {
              children: "./.env"
            }), " 변경은 ", _jsx(_components.strong, {
              children: "모든"
            }), " 작업이 캐시를 미스하게 함"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.a, {
              href: "/docs/reference/configuration#globalenv",
              children: _jsx(_components.code, {
                children: "globalEnv"
              })
            }), "에 나열된 변수의 값"]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "globalEnv"
            }), "에 나열된 ", _jsx(_components.code, {
              children: "GITHUB_TOKEN"
            }), " 값 변경"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "작업 런타임에 영향을 미치는 플래그 값"
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "--cache-dir"
            }), ", ", _jsx(_components.code, {
              children: "--framework-inference"
            }), " 또는 ", _jsx(_components.code, {
              children: "--env-mode"
            }), "와 같은 동작 변경 플래그 사용"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "임의 패스스루 인수"
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "turbo build -- --arg=value"
            }), "는 ", _jsx(_components.code, {
              children: "turbo build"
            }), " 또는 ", _jsx(_components.code, {
              children: "turbo build -- --arg=diff"
            }), "와 비교하여 캐시를 미스함"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "패키지-해시-입력",
      children: "패키지 해시 입력"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "입력"
          }), _jsx(_components.th, {
            children: "예시"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.a, {
              href: "/docs/reference/package-configurations",
              children: "패키지 구성"
            }), " 변경"]
          }), _jsxs(_components.td, {
            children: ["패키지의 ", _jsx(_components.code, {
              children: "turbo.json"
            }), " 변경"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "패키지에 영향을 미치는 Lockfile 변경"
          }), _jsxs(_components.td, {
            children: ["패키지의 ", _jsx(_components.code, {
              children: "package.json"
            }), "에서 종속성 업데이트"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: ["패키지의 ", _jsx(_components.code, {
              children: "package.json"
            }), " 변경"]
          }), _jsxs(_components.td, {
            children: ["패키지의 ", _jsx(_components.code, {
              children: "package.json"
            }), "에서 ", _jsx(_components.code, {
              children: "name"
            }), " 필드 업데이트"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "소스 제어의 파일 변경"
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "src/index.ts"
            }), "에 새 코드 작성"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "문제-해결",
      children: "문제 해결"
    }), "\n", _jsx(_components.h3, {
      id: "dry-run-사용",
      children: "Dry run 사용"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo에는 실제로 실행하지 않고 작업을 실행하면 어떤 일이 발생하는지 확인할 수 있는 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--dry----dry-run",
        children: [_jsx(_components.code, {
          children: "--dry"
        }), " 플래그"]
      }), "가 있습니다. 이는 어떤 작업을 실행하고 있는지 확실하지 않을 때 캐싱 문제를 디버깅하는 데 유용할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--dry----dry-run",
        children: [_jsx(_components.code, {
          children: "--dry"
        }), " API 참조"]
      }), "를 방문하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "run-summary-사용",
      children: "Run Summary 사용"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo에는 작업의 모든 입력, 출력 등에 대한 개요를 얻는 데 사용할 수 있는 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--summarize",
        children: [_jsx(_components.code, {
          children: "--summarize"
        }), " 플래그"]
      }), "가 있습니다. 두 요약을 비교하면 두 작업의 해시가 다른 이유를 알 수 있습니다. 이는 다음과 같은 경우에 유용할 수 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "입력 디버깅: Turborepo의 작업에는 많은 입력이 있습니다. 작업이 캐시를 히트할 것으로 예상했는데 미스하는 경우 Run Summary를 사용하여 예상하지 못한 입력이 다른지 확인할 수 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "출력 디버깅: 캐시 히트가 예상한 파일을 복원하지 않는 경우 Run Summary는 캐시에서 복원되는 출력을 이해하는 데 도움이 될 수 있습니다."
      }), "\n"]
    }), "\n", _jsx(Callout, {
      type: "info",
      title: "Summary 뷰어",
      children: _jsxs(_components.p, {
        children: ["Turborepo 네이티브 Run Summary UI 뷰어는 없지만, Run Summary를 웹 뷰로 보고\n싶다면 커뮤니티에서 만든\n", _jsx(_components.a, {
          href: "https://turbo.nullvoxpopuli.com",
          children: "https://turbo.nullvoxpopuli.com"
        }), "을 사용하는\n것을 권장합니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "캐싱-끄기",
      children: "캐싱 끄기"
    }), "\n", _jsxs(_components.p, {
      children: ["때때로 작업의 출력을 캐시에 쓰지 않을 수 있습니다. 이는 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#cache",
        children: _jsx(_components.code, {
          children: "\"cache\": false"
        })
      }), "를 사용하여 작업에 대해 영구적으로 설정하거나 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--no-cache",
        children: ["the ", _jsx(_components.code, {
          children: "--cache <options>"
        }), " 플래그"]
      }), "를 사용하여 전체 실행에 대해 설정할 수 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "캐시-덮어쓰기",
      children: "캐시 덮어쓰기"
    }), "\n", _jsxs(_components.p, {
      children: ["캐시된 작업을 강제로 다시 실행하려면 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--force",
        children: [_jsx(_components.code, {
          children: "--force"
        }), " 플래그"]
      }), "를 사용합니다. 이는 캐시 ", _jsx(_components.strong, {
        children: "읽기"
      }), "를 비활성화하며 ", _jsx(_components.strong, {
        children: "쓰기"
      }), "는 비활성화하지 않습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "작업-캐싱이-작업-실행보다-느림",
      children: "작업 캐싱이 작업 실행보다 느림"
    }), "\n", _jsx(_components.p, {
      children: "캐싱이 캐싱하지 않는 것보다 느린 시나리오를 만드는 것이 가능합니다. 이러한 경우는 드물지만 몇 가지 예는 다음과 같습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "매우 빠르게 실행되는 작업"
        }), ": 작업이 ", _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching",
          children: "Remote Cache"
        }), "로의 네트워크 왕복보다 빠르게 실행되는 경우 작업을 캐시하지 않는 것을 고려해야 합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "출력 자산이 엄청나게 큰 작업"
        }), ": 업로드 또는 다운로드하는 데 걸리는 시간이 재생성하는 데 걸리는 시간을 초과하는 것처럼 완전한 Docker 컨테이너와 같이 너무 큰 아티팩트를 만드는 것이 가능합니다. 이러한 경우 작업을 캐시하지 않는 것을 고려해야 합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "자체 캐싱이 있는 스크립트"
        }), ": 일부 작업에는 자체 내부 캐싱 동작이 있습니다. 이러한 경우 Turborepo의 캐시와 애플리케이션 캐시가 함께 작동하도록 구성이 빠르게 복잡해질 수 있습니다."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "이러한 상황은 드물지만 특정 위치에서 캐싱을 비활성화하는 것이 성능 이점을 제공하는지 확인하기 위해 프로젝트의 동작을 테스트해야 합니다."
    }), "\n", _jsx(_components.h2, {
      id: "다음-단계",
      children: "다음 단계"
    }), "\n", _jsx(_components.p, {
      children: "이제 Turborepo의 캐싱이 저장소를 어떻게 더 빠르게 만드는지 보았으므로 Turborepo에서 애플리케이션과 라이브러리를 개발하는 방법을 살펴보겠습니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
